import { useState, useEffect, useCallback } from 'react';

const useBrazilianStates = () => {
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
            .then(response => response.json())
            .then(data => {
                setStates(data.map(state => ({ sigla: state.sigla, nome: state.nome })));
            })
            .catch(error => console.error("Erro ao buscar estados:", error));
    }, []);

    const fetchCitiesForState = useCallback(async (uf) => {
        if (!uf) {
            setCities([]);
            return [];
        }
        setLoading(true);
        try {
            const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
            const data = await response.json();
            const cityNames = data.map(city => city.nome);
            setCities(cityNames);
            setLoading(false);
            return cityNames; // Retorna para que possamos usar o await
        } catch (error) {
            console.error("Erro ao buscar cidades:", error);
            setLoading(false);
            return [];
        }
    }, []);

    return { states, cities, loading, fetchCitiesForState };
};

export default useBrazilianStates;
